<template>
  <div class="svip-bg">
    <div class="info">
        <div class="flex-c-b">
            <van-image height="2.23rem" fit="contain" src="/static/newImg/active/2/svip_icon_s1.avif"/>
            <div class="c">
                <div class="flex-c-start">
                  当前等级 <div class="grap">SVIP 0</div> 
                </div>
                <p>距离下个等级，还需充值1,000.00&nbsp;<van-icon name="replay" color="#fff" size="15"/></p>
                <van-progress :percentage="50" :show-pivot="false" />
            </div>
            <div class="r">
                <div class="flex-c-start svip-points-row">
                    <img src="/static/newImg/svip/svip_icon_jf_2.avif" class="svip-points-icon" />
                    <span class="svip-points-num">0.00</span>
                    <img src="/static/newImg/svip/eggs.png" class="svip-eggs-icon" />
                </div>
                <div class="cz">前往充值</div>
            </div>
        </div>
        <div class="tip">只要使用<span>K豆钱包、虚拟币、数字钱包、波币钱包、购宝钱包、数字货币...</span><span class="tip-more" @click="showWalletPopup = true">更多</span>，每充值1=1.00积分，还可升级金融SVIP获得对应奖金</div>
    </div>

    <div class="svip-content">
      <!-- 子选项卡 -->
      <div class="sub-tabs">
        <div class="sub-tab-item" :class="{ active: activeSubTab === 0 }" @click="activeSubTab = 0">金融SVIP奖励</div>
        <div class="sub-tab-item" :class="{ active: activeSubTab === 1 }" @click="activeSubTab = 1">规则说明</div>
        <div class="sub-tab-item" :class="{ active: activeSubTab === 2 }" @click="activeSubTab = 2">充值记录</div>
        <div class="sub-tab-item" :class="{ active: activeSubTab === 3 }" @click="activeSubTab = 3">积分记录</div>
      </div>

      <!-- 等级奖金表格 -->
      <div class="tab-content" v-if="activeSubTab === 0">
      <div class="svip-table">
        <div class="table-header">
          <div class="th-level">等级</div>
          <div class="th-reward">奖金</div>
        </div>
        <div class="table-body">
          <div class="table-row" v-for="(level, idx) in svipLevels" :key="idx">
            <div class="td-level">
              <div class="level-badge-row">
                <img :src="'/static/newImg/svip/' + level.icon" class="level-icon" />
                <div class="level-badge" :style="{ background: level.badgeColor }">
                  <span class="level-num">{{ level.name }}</span>
                </div>
              </div>
              <div class="level-up-info" v-if="level.upAmount">
                晋级再充值{{ level.upAmount }}
              </div>
            </div>
            <div class="td-reward">
              <div class="reward-item" v-for="(bonus, bIdx) in level.bonuses" :key="bIdx">
                <img :src="'/static/newImg/svip/svip_icon_jjj0' + (bIdx + 1) + '.avif'" class="reward-icon-img" />
                <div class="reward-text" v-if="bonus.type === 'gear'">
                  晋级奖金 <span class="hl">{{ bonus.amount }}</span>
                </div>
                <div class="reward-text" v-else-if="bonus.type === 'weekly'">
                  每周充值<span class="wh">≥{{ bonus.condition }}</span>,奖金<span class="hl">{{ bonus.amount }}</span>
                </div>
                <div class="reward-text" v-else-if="bonus.type === 'monthly'">
                  每月充值<span class="wh">≥{{ bonus.condition }}</span>,奖金<span class="hl">{{ bonus.amount }}</span>
                </div>
                <div class="reward-text" v-else-if="bonus.type === 'points'">
                  获得积分数<span class="wh">{{ bonus.amount }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>

      <!-- 规则说明 -->
      <div class="tab-content" v-if="activeSubTab === 1">
      <div class="svip-rules">
        <div class="rules-content" v-html="rulesText"></div>
      </div>
      </div>

      <!-- 充值记录 -->
      <div class="tab-content" v-if="activeSubTab === 2">
      <div class="svip-records">
        <div class="records-filter">
          <div class="filter-left">
            <div class="filter-select" @click="showTimePopup = !showTimePopup">
              <span>{{ timeOptions[timeIndex].text }}</span>
              <van-icon :name="showTimePopup ? 'arrow-up' : 'arrow-down'" size="14" />
              <!-- 时间弹框 -->
              <div class="time-popup" v-if="showTimePopup">
                <div class="time-grid">
                  <div v-for="(opt, idx) in timeOptions" :key="idx"
                       class="time-option" :class="{ active: timeIndex === idx }"
                       @click.stop="timeIndex = idx">
                    {{ opt.text }}
                  </div>
                </div>
                <div class="time-btns">
                  <div class="time-btn time-btn-cancel" @click.stop="showTimePopup = false">取消</div>
                  <div class="time-btn time-btn-confirm" @click.stop="showTimePopup = false">确认</div>
                </div>
              </div>
            </div>
          </div>
          <div class="filter-right">
            累计充值 <span class="filter-amount">0.00</span>
          </div>
        </div>
        <div class="records-empty">
          <img src="/static/image/img_none_sj.avif" class="empty-icon" alt="" />
          <div class="empty-text">今日暂无记录，<span class="empty-link">可查看更多</span></div>
        </div>
      </div>
      </div>

      <!-- 积分记录 -->
      <div class="tab-content" v-if="activeSubTab === 3">
      <div class="svip-records">
        <div class="records-filter">
          <div class="filter-left">
            <div class="filter-select" @click="showTimePopup = !showTimePopup">
              <span>{{ timeOptions[timeIndex].text }}</span>
              <van-icon :name="showTimePopup ? 'arrow-up' : 'arrow-down'" size="14" />
              <!-- 时间弹框 -->
              <div class="time-popup" v-if="showTimePopup">
                <div class="time-grid">
                  <div v-for="(opt, idx) in timeOptions" :key="idx"
                       class="time-option" :class="{ active: timeIndex === idx }"
                       @click.stop="timeIndex = idx">
                    {{ opt.text }}
                  </div>
                </div>
                <div class="time-btns">
                  <div class="time-btn time-btn-cancel" @click.stop="showTimePopup = false">取消</div>
                  <div class="time-btn time-btn-confirm" @click.stop="showTimePopup = false">确认</div>
                </div>
              </div>
            </div>
            <div class="filter-select" @click="showTypePopup = !showTypePopup">
              <span>{{ typeOptions[typeIndex].text }}</span>
              <van-icon :name="showTypePopup ? 'arrow-up' : 'arrow-down'" size="14" />
              <!-- 类型下拉 -->
              <div class="type-dropdown" v-if="showTypePopup">
                <div v-for="(opt, idx) in typeOptions" :key="idx"
                     class="type-option" :class="{ active: typeIndex === idx }"
                     @click.stop="typeIndex = idx; showTypePopup = false;">{{ opt.text }}</div>
              </div>
            </div>
          </div>
          <div class="filter-right">
            总计 <span class="filter-amount">0.00</span>
          </div>
        </div>
        <div class="records-empty">
          <img src="/static/image/img_none_sj.avif" class="empty-icon" alt="" />
          <div class="empty-text">今日暂无记录，<span class="empty-link">可查看更多</span></div>
        </div>
      </div>
      </div>
    </div>

    <!-- 钱包弹框 -->
    <div class="wallet-popup-mask" v-if="showWalletPopup">
      <div class="wallet-popup">
        <div class="wallet-title">仅限充值</div>
        <div class="wallet-item">K豆钱包、虚拟币、数字钱包、波币钱包、购宝钱包、数字货币、No钱包、CGPAY钱包、NO钱包USDT、钱能钱包</div>
      </div>
      <div class="wallet-close" @click="showWalletPopup = false">
        <van-icon name="cross" size="20" color="#fff" />
      </div>
    </div>

    <div style="height:2rem;"></div>
  </div>
</template>
<script>
export default {
  name: "svip",
  data() {
    return {
      activeSubTab: 0,
      showTimePopup: false,
      showTypePopup: false,
      showWalletPopup: false,
      timeIndex: 0,
      typeIndex: 0,
      timeOptions: [
        { text: '今日', value: 0 },
        { text: '昨日', value: 1 },
        { text: '本周', value: 2 },
        { text: '上周', value: 3 },
        { text: '本月', value: 4 },
        { text: '上月', value: 5 },
        { text: '全部', value: 6 },
      ],
      typeOptions: [
        { text: '全部', value: 0 },
        { text: '充值获得', value: 1 },
        { text: '已使用', value: 2 },
        { text: '已过期', value: 3 },
        { text: '系统赠送', value: 4 },
        { text: '奖励获得', value: 5 },
      ],
      rulesText: '<div class="rule-lead">领取条件：当日存款任意金额且近期90天内打码达到充值的三倍流水才能领取。</div><div class="rule-title">规格说明：</div><div class="rule-item">1.晋级标准：使用以上指定充值方式累计充值金额满足SVIP晋级要求，即可晋级相应SVIP等级，获得相应晋级奖金，如连续晋级多级，可领取全部等级晋级奖金，奖金实时领取。</div><div class="rule-item">2.周奖励：每周充值金额达到当前SVIP等级对应要求，即可领取对应周奖金，如连续晋级多级，只可领取当前最高等级对应奖金，奖金下周一00:00:00以后才可领取。</div><div class="rule-item">3.月奖励：每月充值金额达到当前SVIP等级对应要求，即可领取对应月奖金，如连续晋级多级，只可领取当前最高等级对应奖金，奖金下月1日00:00:00以后才可领取。</div><div class="rule-item">4.积分说明：每次充值赠送对应等级比例积分，等级越高赠送积分越多，获得的积分可用于抽奖，30天后未使用则过期作废。</div><div class="rule-item">5.SVIP更新频率：会员每次充值后自动更新SVIP等级，若未更新可进入详情页刷新。</div><div class="rule-item">6.稽核说明：所赠送的奖金（不含本金）需1.00倍有效投注，投注不限游戏平台，使用【USDT/所有虚拟币钱包】才能提现。</div><div class="rule-item">7.活动声明：本功能仅限账号本人进行正常游戏投注，禁止租借账号、无风险投注(对赌、对刷、低赔刷水)、恶意套利、使用外挂程式、机器人、利用协议、漏洞、接口、群控或其他技术手段参与，一经查核属实，本平台有权终止会员登录、暂停会员使用网站、及没收奖金和不当盈利的权利，无需特别通知。</div><div class="rule-item">8.解释说明：会员领取奖励时，本平台将默认会员同意且遵守对应条件等相关规定，为避免文字理解歧义，本平台保有本活动最终解释权。</div>',
      svipLevels: [
        { id: 0, name: 'SVIP 0', icon: 'svip_icon_s0.avif', badgeColor: 'linear-gradient(90deg, #91ade6 11.28%, #a8c4ff)', upAmount: '', bonuses: [{ type: 'points', amount: '1倍' }] },
        { id: 1, name: 'SVIP 1', icon: 'svip_icon_s1.avif', badgeColor: 'linear-gradient(90deg, #00ca29 11.28%, #02e331)', upAmount: '1,000', bonuses: [{ type: 'gear', amount: '5.00' }, { type: 'weekly', condition: '500', amount: '3.00' }, { type: 'monthly', condition: '1000', amount: '5.00' }, { type: 'points', amount: '1倍' }] },
        { id: 2, name: 'SVIP 2', icon: 'svip_icon_s2.avif', badgeColor: 'linear-gradient(90deg, #00ca29 11.28%, #02e331)', upAmount: '10,000', bonuses: [{ type: 'gear', amount: '18.00' }, { type: 'weekly', condition: '500', amount: '5.00' }, { type: 'monthly', condition: '1000', amount: '8.00' }, { type: 'points', amount: '1倍' }] },
        { id: 3, name: 'SVIP 3', icon: 'svip_icon_s3.avif', badgeColor: 'linear-gradient(90deg, #0abff2 11.28%, #28d1ff)', upAmount: '50,000', bonuses: [{ type: 'gear', amount: '88.00' }, { type: 'weekly', condition: '500', amount: '8.00' }, { type: 'monthly', condition: '1000', amount: '12.00' }, { type: 'points', amount: '1倍' }] },
        { id: 4, name: 'SVIP 4', icon: 'svip_icon_s4.avif', badgeColor: 'linear-gradient(90deg, #0abff2 11.28%, #28d1ff)', upAmount: '100,000', bonuses: [{ type: 'gear', amount: '188.00' }, { type: 'weekly', condition: '500', amount: '12.00' }, { type: 'monthly', condition: '1000', amount: '28.00' }, { type: 'points', amount: '1倍' }] },
        { id: 5, name: 'SVIP 5', icon: 'svip_icon_s5.avif', badgeColor: 'linear-gradient(90deg, #0c77f2 11.28%, #1180ff)', upAmount: '200,000', bonuses: [{ type: 'gear', amount: '288.00' }, { type: 'weekly', condition: '800', amount: '15.00' }, { type: 'monthly', condition: '2000', amount: '58.00' }, { type: 'points', amount: '1倍' }] },
        { id: 6, name: 'SVIP 6', icon: 'svip_icon_s6.avif', badgeColor: 'linear-gradient(90deg, #0c77f2 11.28%, #1180ff)', upAmount: '500,000', bonuses: [{ type: 'gear', amount: '588.00' }, { type: 'weekly', condition: '1000', amount: '18.00' }, { type: 'monthly', condition: '3000', amount: '88.00' }, { type: 'points', amount: '1倍' }] },
        { id: 7, name: 'SVIP 7', icon: 'svip_icon_s7.avif', badgeColor: 'linear-gradient(90deg, #f27018 11.28%, #ff8836)', upAmount: '1,000,000', bonuses: [{ type: 'gear', amount: '888.00' }, { type: 'weekly', condition: '1000', amount: '28.00' }, { type: 'monthly', condition: '5000', amount: '138.00' }, { type: 'points', amount: '1倍' }] },
        { id: 8, name: 'SVIP 8', icon: 'svip_icon_s8.avif', badgeColor: 'linear-gradient(90deg, #f27018 11.28%, #ff8836)', upAmount: '2,000,000', bonuses: [{ type: 'gear', amount: '1,388.00' }, { type: 'weekly', condition: '2000', amount: '38.00' }, { type: 'monthly', condition: '6000', amount: '188.00' }, { type: 'points', amount: '1倍' }] },
        { id: 9, name: 'SVIP 9', icon: 'svip_icon_s9.avif', badgeColor: 'linear-gradient(90deg, #edac0f 11.28%, #ffc326)', upAmount: '5,000,000', bonuses: [{ type: 'gear', amount: '1,588.00' }, { type: 'weekly', condition: '3000', amount: '58.00' }, { type: 'monthly', condition: '8000', amount: '238.00' }, { type: 'points', amount: '1倍' }] },
        { id: 10, name: 'SVIP 10', icon: 'svip_icon_s10.avif', badgeColor: 'linear-gradient(90deg, #edac0f 11.28%, #ffc326)', upAmount: '5,000,000', bonuses: [{ type: 'gear', amount: '1,888.00' }, { type: 'weekly', condition: '3000', amount: '88.00' }, { type: 'monthly', condition: '10000', amount: '288.00' }, { type: 'points', amount: '1倍' }] },
        { id: 11, name: 'SVIP 11', icon: 'svip_icon_s11.avif', badgeColor: 'linear-gradient(90deg, #d07e01 11.28%, #f2a330)', upAmount: '5,000,000', bonuses: [{ type: 'gear', amount: '2,388.00' }, { type: 'weekly', condition: '5000', amount: '138.00' }, { type: 'monthly', condition: '20000', amount: '388.00' }, { type: 'points', amount: '1倍' }] },
        { id: 12, name: 'SVIP 12', icon: 'svip_icon_s12.avif', badgeColor: 'linear-gradient(90deg, #d07e01 11.28%, #f2a330)', upAmount: '5,000,000', bonuses: [{ type: 'gear', amount: '2,588.00' }, { type: 'weekly', condition: '10000', amount: '158.00' }, { type: 'monthly', condition: '50000', amount: '488.00' }, { type: 'points', amount: '1倍' }] },
        { id: 13, name: 'SVIP 13', icon: 'svip_icon_s13.avif', badgeColor: 'linear-gradient(270deg, #fc52e2, #ed2dce 95.77%)', upAmount: '5,000,000', bonuses: [{ type: 'gear', amount: '2,888.00' }, { type: 'weekly', condition: '20000', amount: '188.00' }, { type: 'monthly', condition: '100000', amount: '588.00' }, { type: 'points', amount: '1倍' }] },
        { id: 14, name: 'SVIP 14', icon: 'svip_icon_s14.avif', badgeColor: 'linear-gradient(270deg, #fc52e2, #ed2dce 95.77%)', upAmount: '5,000,000', bonuses: [{ type: 'gear', amount: '3,888.00' }, { type: 'weekly', condition: '40000', amount: '238.00' }, { type: 'monthly', condition: '200000', amount: '688.00' }, { type: 'points', amount: '1倍' }] },
        { id: 15, name: 'SVIP 15', icon: 'svip_icon_s15.avif', badgeColor: 'linear-gradient(90deg, #7d24f2 11.28%, #9747ff)', upAmount: '5,000,000', bonuses: [{ type: 'gear', amount: '4,888.00' }, { type: 'weekly', condition: '50000', amount: '288.00' }, { type: 'monthly', condition: '300000', amount: '888.00' }, { type: 'points', amount: '1倍' }] },
        { id: 16, name: 'SVIP 16', icon: 'svip_icon_s16.avif', badgeColor: 'linear-gradient(90deg, #7d24f2 11.28%, #9747ff)', upAmount: '5,000,000', bonuses: [{ type: 'gear', amount: '5,888.00' }, { type: 'weekly', condition: '60000', amount: '338.00' }, { type: 'monthly', condition: '500000', amount: '988.00' }, { type: 'points', amount: '1倍' }] },
        { id: 17, name: 'SVIP 17', icon: 'svip_icon_s17.avif', badgeColor: 'linear-gradient(90deg, #eb110b 11.28%, #ff3d37)', upAmount: '20,000,000', bonuses: [{ type: 'gear', amount: '8,888.00' }, { type: 'weekly', condition: '70000', amount: '388.00' }, { type: 'monthly', condition: '500000', amount: '1,888.00' }, { type: 'points', amount: '1倍' }] },
        { id: 18, name: 'SVIP 18', icon: 'svip_icon_s18.avif', badgeColor: 'linear-gradient(90deg, #eb110b 11.28%, #ff3d37)', upAmount: '50,000,000', bonuses: [{ type: 'gear', amount: '18,888.00' }, { type: 'weekly', condition: '80000', amount: '488.00' }, { type: 'monthly', condition: '500000', amount: '3,888.00' }, { type: 'points', amount: '1倍' }] },
        { id: 19, name: 'SVIP 19', icon: 'svip_icon_s19.avif', badgeColor: 'linear-gradient(270deg, #424242, #2c2c2c 95.77%)', upAmount: '50,000,000', bonuses: [{ type: 'gear', amount: '38,888.00' }, { type: 'weekly', condition: '90000', amount: '588.00' }, { type: 'monthly', condition: '500000', amount: '5,888.00' }, { type: 'points', amount: '1倍' }] },
        { id: 20, name: 'SVIP 20', icon: 'svip_icon_s20.avif', badgeColor: 'linear-gradient(270deg, #424242, #2c2c2c 95.77%)', upAmount: '500,000,000', bonuses: [{ type: 'gear', amount: '88,888.00' }, { type: 'weekly', condition: '100000', amount: '888.00' }, { type: 'monthly', condition: '500000', amount: '8,888.00' }, { type: 'points', amount: '1倍' }] }
      ]
    };
  },
  created() {

  },
  methods: {

  }
};
</script>

<style lang="scss" scoped>
@import '../../../static/css/common.css';
.svip-bg{
    width: 100%;
    min-height: 90vh;
    color: #fff;
    background: #7c89ea;
    box-shadow: 0 .03rem .1rem rgba(0,0,0,.06);
    margin-top: 1rem;
}
.info {
  height: 3.96rem;
  background: url('/static/newImg/active/2/svip_bg.avif');
  background-size: cover;
  padding: .3rem;
  .c{
    .grap{background: linear-gradient(90deg,#91ade6 11.28%,#a8c4ff);height: .4rem;
    border-radius: .2rem;
    line-height: .4rem;color: #fff;
    font-size: .25rem;
    font-weight: 700;font-style: italic; margin-left: .08rem;padding: 0 .35rem;}
    p{font-size: .28rem;margin: .3rem 0;}
  }
  .r{
    .svip-points-row {
      align-items: center;
      gap: .1rem;
      margin-bottom: .1rem;
    }
    .svip-points-icon {
      width: .5rem;
      height: .5rem;
    }
    .svip-eggs-icon {
      width: .5rem;
      height: auto;
    }
    .svip-points-num {
      font-size: .3rem;
      color: #fff;
      font-weight: bold;
    }
    .cz{  width: 1.05rem; text-align: center;font-size: .2rem;height: .52rem;line-height: .52rem;
    margin-left: .17rem;
    padding: 0 .13rem;
    border-radius: .08rem;
    background: #ffaa09;
    color: #fff;}
  }
  .tip{
    color: #cfd6ff;
    font-size: .25rem;
    font-weight: 400;
    padding: 0 .2rem;
    margin-top: .2rem;
    margin-bottom: .2rem;
    span{color: #fff;font-size: .25rem;}
}
}

/* 内容区域 */
.svip-content {
  background-color: #5966c5;
  border-radius: 0.2rem;
  margin: 0 0.3rem 0.3rem;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .tab-content {
    padding-bottom: 0.3rem;
    height: calc(100vh - 9.5rem);
    overflow-y: auto;
  }
}

/* 子选项卡 */
.sub-tabs {
  display: flex;
  padding: 0.2rem 0.3rem;
  gap: 0.1rem;
  border-bottom: 1px solid rgba(255,255,255,0.15);

  .sub-tab-item {
    flex: 1;
    text-align: center;
    padding: 0.15rem 0;
    font-size: 0.3rem;
    color: #fff;
    border-bottom: 2px solid transparent;
    cursor: pointer;

    &.active {
      color: #ffdfb9;
      border-bottom-color: #ffaa09;
      font-weight: bold;
    }
  }
}

/* 等级奖金表格 */
.svip-table {
  margin: 0.2rem 0.3rem;
  border: 1px solid rgba(255,255,255,0.3);
  border-radius: 0.1rem;
  overflow: hidden;

  .table-header {
    display: flex;
    border-bottom: 1px solid rgba(255,255,255,0.3);

    .th-level {
      width: 35%;
      text-align: center;
      padding: 0.2rem 0;
      font-size: 0.3rem;
      font-weight: bold;
      border-right: 1px solid rgba(255,255,255,0.3);
    }

    .th-reward {
      width: 65%;
      text-align: center;
      padding: 0.2rem 0;
      font-size: 0.3rem;
      font-weight: bold;
    }
  }

  .table-body {
    .table-row {
      display: flex;
      border-bottom: 1px solid rgba(255,255,255,0.15);

      &:last-child {
        border-bottom: none;
      }

      .td-level {
        width: 35%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 0.25rem 0.1rem;
        border-right: 1px solid rgba(255,255,255,0.15);

        .level-badge-row {
          display: flex;
          align-items: center;
          margin-bottom: 0.1rem;
        }

        .level-icon {
          width: 0.55rem;
          height: 0.55rem;
          flex-shrink: 0;
          position: relative;
          z-index: 2;
          margin-right: -0.15rem;
        }

        .level-badge {
          display: inline-flex;
          align-items: center;
          padding: 0.08rem 0.2rem;
          border-radius: 0.15rem;
          margin-bottom: 0;
          position: relative;
          z-index: 1;

          .level-num {
            font-size: 0.28rem;
            font-weight: bold;
            font-style: italic;
            color: #fff;
          }
        }

        .level-up-info {
          font-size: 0.22rem;
          color: rgba(255,255,255,0.7);
          text-align: center;
        }
      }

      .td-reward {
        width: 65%;
        padding: 0.15rem 0.2rem;

        .reward-item {
          display: flex;
          align-items: center;
          padding: 0.08rem 0;
          font-size: 0.3rem;

          .reward-icon-img {
            width: 0.4rem;
            height: 0.4rem;
            margin-right: 0.15rem;
            flex-shrink: 0;
          }

          .reward-text {
            color: #cfd6ff;
            font-size: 0.3rem;

            .hl {
              color: #ffc23d;
              font-weight: bold;
            }
            .wh {
              color: #fff;
            }
          }
        }
      }
    }
  }
}

/* 规则说明 */
.svip-rules {
  padding: 0.3rem;

  .rules-content {
    font-size: 0.28rem;
    color: rgba(255,255,255,0.8);
    line-height: 1.8;

    ::v-deep .rule-lead {
      font-weight: bold;
      color: #fff;
      margin-bottom: 0.3rem;
      padding-bottom: 0.2rem;
      border-bottom: 1px solid rgba(255,255,255,0.2);
    }

    ::v-deep .rule-title {
      font-weight: bold;
      color: #fff;
      margin: 0.3rem 0 0.2rem;
    }

    ::v-deep .rule-item {
      margin-bottom: 0.2rem;
      padding-left: 0.1rem;
    }
  }
}

/* 类型下拉 */
.type-dropdown {
  position: absolute;
  top: calc(100% + 0.1rem);
  left: 0;
  background: #5966c5;
  border: 1px solid rgba(255,255,255,0.2);
  border-radius: 0.1rem;
  z-index: 10;
  min-width: 2rem;
  overflow: hidden;

  .type-option {
    padding: 0.2rem 0.3rem;
    font-size: 0.28rem;
    color: rgba(255,255,255,0.7);
    text-align: center;

    &.active {
      color: #ffdfb9;
      background: rgba(255,223,185,0.1);
    }
  }
}

/* 时间选择弹框 */
.time-popup {
  position: absolute;
  top: calc(100% + 0.1rem);
  left: 0;
  background: #5966c5;
  border: 1px solid rgba(255,255,255,0.2);
  border-radius: 0.2rem;
  padding: 0.3rem;
  z-index: 100;
  min-width: 5rem;

  .time-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0.15rem;
    margin-bottom: 0.3rem;

    .time-option {
      padding: 0.2rem 0;
      text-align: center;
      border: 1px solid rgba(255,255,255,0.3);
      border-radius: 0.1rem;
      font-size: 0.28rem;
      color: #fff;

      &.active {
        border-color: #ffdfb9;
        color: #ffdfb9;
        background: rgba(255,223,185,0.1);
      }
    }
  }

  .time-btns {
    display: flex;
    gap: 0.2rem;

    .time-btn {
      flex: 1;
      padding: 0.2rem 0;
      text-align: center;
      border-radius: 0.1rem;
      font-size: 0.3rem;
    }

    .time-btn-cancel {
      background: rgba(255,255,255,0.1);
      color: #fff;
    }

    .time-btn-confirm {
      background: #ffdfb9;
      color: #333;
    }
  }
}

/* 记录筛选栏 */
.records-filter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.2rem 0.3rem;

  .filter-left {
    display: flex;
    gap: 0.15rem;
  }

  .filter-select {
    display: flex;
    align-items: center;
    gap: 0.08rem;
    padding: 0.1rem 0.25rem;
    border: 1px solid rgba(255,255,255,0.3);
    border-radius: 0.3rem;
    font-size: 0.26rem;
    color: #fff;
    background: rgba(255,255,255,0.05);
    position: relative;
  }

  .filter-right {
    font-size: 0.26rem;
    color: rgba(255,255,255,0.7);

    .filter-amount {
      color: #fff;
      font-weight: bold;
      font-size: 0.3rem;
    }
  }
}

/* 记录空状态 */
.svip-records {
  padding: 0;
  position: relative;

  .records-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 2rem 0;
    gap: 0.3rem;

    .empty-icon {
      width: 2.5rem;
      height: 2.5rem;
      opacity: 0.5;
    }

    .empty-text {
      font-size: 0.28rem;
      color: rgba(255,255,255,0.6);

      .empty-link {
        color: #DFB372;
      }
    }
  }
}

/* 钱包弹框 */
.wallet-popup-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  z-index: 999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .wallet-popup {
    background: #1a1a1a;
    border-radius: 0.2rem;
    padding: 0.4rem 0.6rem;
    width: 60%;
    
    .wallet-title {
      text-align: center;
      font-size: 0.32rem;
      color: #fff;
      margin-bottom: 0.3rem;
    }

    .wallet-item {
      text-align: center;
      font-size: 0.3rem;
      color: #fff;
      padding: 0.2rem 0;
    }
  }

  .wallet-close {
    margin-top: 0.3rem;
    width: 0.6rem;
    height: 0.6rem;
    border-radius: 50%;
    border: 2px solid #fff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

/* 更多按钮 */
.tip-more {
  color: #fff;
  cursor: pointer;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/component/svip.vue